import React from "react";
import { Dropdown } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "./styles.scss";

export interface IHookFormSelectProps {
  options: { label: string; value: string }[];
  name: string;
  label?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const HookFormSelect = ({
  options,
  name,
  label,
  placeholder,
  className,
  disabled,
}: IHookFormSelectProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`common.dropdown.${key}`);
  const { control } = useFormContext();

  return (
    <div className={`hook-form-select ${className ?? ""}`}>
      {label && <label htmlFor={name}>{label}</label>}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Dropdown>
            <Dropdown.Toggle disabled={disabled}>
              {options.find((option) => option.value === field.value)?.label ??
                placeholder ??
                t("select")}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {options.map((option) => (
                <Dropdown.Item
                  onClick={() => field.onChange(option.value)}
                  key={option.value}
                >
                  {option.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      />
    </div>
  );
};
